import React, { Suspense, lazy, useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  useParams,
  useHistory,
} from "react-router-dom";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
import { StyledEngineProvider } from "@mui/material/styles";

const generateClassName = createGenerateClassName({
  seed: "container",
  disableGlobal: true,
});

const CalendarLazy = lazy(() => import("./modules/Calendar"));
const CheckinLazy = lazy(() => import("./modules/Checkin"));
const ThreatsLazy = lazy(() => import("./modules/Threats"));

const LoadingSpinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <div
      style={{
        position: "relative",
        width: "80px",
        height: "80px",
      }}
    >
      {/* Spinner Circle */}
      <div
        style={{
          boxSizing: "border-box",
          border: "6px solid #f3f3f3",
          borderTop: "6px solid #007BFF",
          borderRadius: "50%",
          width: "100%",
          height: "100%",
          animation: "spin 1s linear infinite",
        }}
      />
      
      {/* Logo or Text in Center */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "16px",
          color: "#007BFF",
          fontWeight: "bold",
        }}
      >
        <img src="/assets/favicon.ico" alt="Logo" style={{ width: '35px', height: '35px' }} />
      </div>
    </div>

    {/* Spinner Animation */}
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

function App() {
  const token: string | null = localStorage.getItem("token") || null;
  const history = useHistory();

  useEffect(() => {
    if (location.pathname.includes("checkin")) {
      if (token && location.pathname.includes("public")) {
        history.push("/");
      }
      if (!token) {
        history.push("/calendar/auth/home");
      }
    }
    if (location.pathname.includes("alerts")) {
      if (!token) {
        const isSignupOrShorturl =
          location.pathname.includes("alerts/signup") ||
          location.pathname.includes("alerts/shorturl");
        const isRootOrEmptyAlerts =
          location.pathname === "/alerts" || location.pathname === "/alerts/";

        if (!isSignupOrShorturl && !isRootOrEmptyAlerts) {
          history.push("/");
        }
      }
    }
  }, [token]);

  return (
    <StylesProvider generateClassName={generateClassName}>
      <div>
        <Suspense fallback={<LoadingSpinner/>}>
          <Switch>
            <Route exact path="/">
              <Redirect to="/calendar" />
            </Route>
            <Route path="/calendar">
              <CalendarLazy />
            </Route>
            <Route path="/checkin">
              <CheckinLazy />
            </Route>
            <Route path="/alerts">
              <ThreatsLazy />
            </Route>
          </Switch>
        </Suspense>
      </div>
    </StylesProvider>
  );
}

export default App;


